import { useState } from "react";
import { Image } from "react-bootstrap";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { LayoutGroup, motion } from "framer-motion";
// internal
import shape_1 from "assets/img/portfolio/masonary/shape/circle-1.png";
import shape_2 from "assets/img/portfolio/masonary/shape/polygon-green.png";
import shape_3 from "assets/img/portfolio/masonary/shape/polygon-pink.png";
import shape_4 from "assets/img/portfolio/masonary/shape/polygon-yellow.png";
// data
import masonry_data from "./masonry-data";
import { MasonrySinglePort } from "components/portfolios/single-item/masonry-single-port";
import ClassicSinglePortfolio from "components/portfolios/single-item/classic-single-portfolio";

const categories = [
  "All",
  ...new Set(masonry_data.map((item) => item.category)),
];

// Initialize 'next' to display all portfolio items immediately
const perView = masonry_data.length;
const next = masonry_data.length;

export function PortfolioMasonryArea({ data = masonry_data }) {
  const [portfolioItems, setPortfolioItems] = useState(data);
  
  return (
    <section className="portfolio__area pb-75 pt-110 p-relative fix">
      <div className="portfolio__shape">
        <Image className="portfolio__shape-20" src={shape_1} alt="shape" />
        <Image className="portfolio__shape-21" src={shape_2} alt="shape" />
        <Image className="portfolio__shape-22" src={shape_3} alt="shape" />
        <Image className="portfolio__shape-23" src={shape_4} alt="shape" />
      </div>
      <div className="container-fluid tp-gx-20">
        <div className="portfolio__section-title-wrapper text-center mb-90">
          <span className="portfolio__section-title-pre">
            CHECK OUT OUR LATEST WORK
          </span>
          <h3 className="portfolio__section-title">Portfolio</h3>
        </div>
        <motion.div layout className="tp-gx-20 grid tp-portfolio-load-more">
          <LayoutGroup>
            <ResponsiveMasonry
              columnsCountBreakPoints={{ 0: 1, 750: 3, 992: 4 }}
            >
              <Masonry gutter="20px">
                {portfolioItems.map((item, i) => (
                  <MasonrySinglePort
                    key={i}
                    item={item}
                    images={portfolioItems}
                    index={i}
                    tooltip_hover={true}
                  />
                ))}
              </Masonry>
            </ResponsiveMasonry>
          </LayoutGroup>
        </motion.div>
      </div>
    </section>
  );
}
